import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="menu"
export default class extends Controller {
  static targets = ['menu', 'overlay'];

  touchStart(e) {
    const touch = e.changedTouches[0];

    this.touchstartX = touch.clientX;
    this.touchstartY = touch.clientY;
  }

  touchEnd(e) {
    if (this.touchstartX == null || this.touchstartY == null) {
      return;
    }

    const touch = e.changedTouches[0];
    const horizontalDistance = this.touchstartX - touch.clientX;
    const verticalDistance = Math.abs(this.touchstartY - touch.clientY);

    this.touchstartX = null;
    this.touchstartY = null;

    if (horizontalDistance > 50 && verticalDistance < 80) {
      this.close();
    }
  }

  open(e) {
    e?.preventDefault();
    this.menuTarget.classList.add('menu--open');
    this.overlayTarget.classList.add('overlay--open');
  }

  close() {
    this.menuTarget.classList.remove('menu--open');
    this.overlayTarget.classList.remove('overlay--open');
  }
}
